import React from 'react';
import { Alert, Box, Button, Chip, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Snackbar, TextField, Typography } from '@mui/material';
import { useUserProfile } from '../hooks/useUserProfile';

export default function UserProfile({ title = 'Perfil de usuario', subtitle = 'Revisa y actualiza tus datos personales y credenciales desde una sola vista.', redirectTo = '/home', allowProfessionEdit = true }) {
  const {
    firstname, setFirstname,
    lastname, setLastname,
    email, setEmail,
    profesional, setProfesional,
    newPassword, setNewPassword,
    confirmPassword, setConfirmPassword,
    isEditing,
    openGood, setOpenGood,
    openError, setOpenError,
    handleEdit, handleCancel, handleSave,
  } = useUserProfile({ redirectTo });

  return (
    <Box sx={{ width: '100%' }}>
      <Paper elevation={0} sx={{ mb: 3, p: { xs: 3, md: 4 }, borderRadius: 3, color: '#fff', background: 'linear-gradient(135deg, #1565c0 0%, #1e88e5 55%, #64b5f6 100%)', boxShadow: '0 18px 40px rgba(21, 101, 192, 0.18)' }}>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', gap: 2 }}>
          <Box>
            <Typography variant="overline" sx={{ opacity: 0.9, letterSpacing: 1.2 }}>{title}</Typography>
            <Typography variant="h3" sx={{ mt: 1, fontSize: { xs: '2rem', md: '2.5rem' }, fontWeight: 700 }}>Bienvenido {firstname}</Typography>
            <Typography sx={{ mt: 1, maxWidth: 620, opacity: 0.92 }}>{subtitle}</Typography>
          </Box>
          <Chip label={isEditing ? 'Modo edicion' : 'Solo lectura'} sx={{ color: '#fff', fontWeight: 600, backgroundColor: isEditing ? 'rgba(255,255,255,0.22)' : 'rgba(255,255,255,0.16)', border: '1px solid rgba(255,255,255,0.25)' }} />
        </Box>
      </Paper>

      <Paper elevation={0} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3, border: '1px solid #e3e8ef', boxShadow: '0 12px 28px rgba(15, 23, 42, 0.06)' }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#1f2937' }}>Datos personales</Typography>
          <Typography sx={{ mt: 1, color: '#6b7280' }}>Puedes consultar tu informacion actual y activar la edicion cuando necesites hacer cambios.</Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}><TextField label="Nombre" fullWidth value={firstname} onChange={(e) => setFirstname(e.target.value)} InputProps={{ readOnly: !isEditing }} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} /></Grid>
          <Grid item xs={12} md={6}><TextField label="Apellidos" fullWidth value={lastname} onChange={(e) => setLastname(e.target.value)} InputProps={{ readOnly: !isEditing }} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} /></Grid>
          <Grid item xs={12} md={6}><TextField label="Email" fullWidth value={email} onChange={(e) => setEmail(e.target.value)} InputProps={{ readOnly: !isEditing }} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} /></Grid>
          {allowProfessionEdit && (
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Profesion</InputLabel>
                <Select label="Profesion" value={profesional} disabled={!isEditing} onChange={(e) => setProfesional(e.target.value)} sx={{ borderRadius: 2 }}>
                  <MenuItem value="Enfermero/a">Enfermero/a</MenuItem>
                  <MenuItem value="Fisioterapeuta">Fisioterapeuta</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
        </Grid>

        <Box sx={{ mt: 4, mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, color: '#1f2937' }}>Seguridad</Typography>
          <Typography sx={{ mt: 1, color: '#6b7280' }}>Si editas tu perfil, aqui puedes establecer una nueva contraseña.</Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}><TextField label="Nueva Contraseña" fullWidth type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} InputProps={{ readOnly: !isEditing }} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} /></Grid>
          <Grid item xs={12} md={6}><TextField label="Volver a introducir contraseña" fullWidth type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} InputProps={{ readOnly: !isEditing }} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} /></Grid>
        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, flexWrap: 'wrap', mt: 4 }}>
          {isEditing ? (
            <>
              <Button variant="outlined" onClick={handleCancel} sx={{ px: 3, py: 1.25, borderRadius: 2 }}>Cancelar edicion</Button>
              <Button variant="contained" color="primary" onClick={handleSave} sx={{ px: 3, py: 1.25, borderRadius: 2 }}>Guardar cambios</Button>
            </>
          ) : (
            <Button variant="contained" color="primary" onClick={handleEdit} sx={{ px: 3, py: 1.25, borderRadius: 2 }}>Editar perfil</Button>
          )}
        </Box>
      </Paper>

      <Snackbar open={openGood} autoHideDuration={2000} onClose={() => setOpenGood(false)}><Alert severity="success" onClose={() => setOpenGood(false)}>Datos actualizados.</Alert></Snackbar>
      <Snackbar open={openError} autoHideDuration={2000} onClose={() => setOpenError(false)}><Alert severity="error" onClose={() => setOpenError(false)}>Las contraseñas no coinciden.</Alert></Snackbar>
    </Box>
  );
}
